export type PlanStatus = 'draft' | 'confirmed' | 'in_progress' | 'completed' | 'partial' | 'recalculated';
export type WeekStatus = 'not_started' | 'ready' | 'forecast' | PlanStatus;
export type ActivityKind = 'review' | 'theory' | 'exercises' | 'simulation' | 'writing';

export const ALL_SUBJECTS_LABEL = 'Todas as disciplinas';

export type TimeRange = {
  id: string;
  start: string;
  end: string;
  breakMinutes: number;
};

export type DayAvailability = {
  weekday: number;
  enabled: boolean;
  ranges: TimeRange[];
};

export type PlanSubject = {
  id: string;
  name: string;
  weight: number;
  percent: number;
  suggestedHours: number;
  color: string;
  selected: boolean;
  previousAccuracy?: number;
  previousCompletion?: number;
  lastStudiedAt?: string;
};

export type ActivityPreference = {
  kind: ActivityKind;
  enabled: boolean;
  durationMinutes: number;
  weeklyFrequency: number;
  preferredWeekday?: number;
  estimatedQuestions?: number;
  scope?: 'all' | 'selected';
  writingType?: string;
};

export type PlanConfiguration = {
  id: string;
  startDate: string;
  endDate: string;
  weeks: number;
  currentWeek: number;
  onlyCurrentWeek: boolean;
  availability: DayAvailability[];
  subjects: PlanSubject[];
  activities: ActivityPreference[];
  cycleBreakMinutes: number;
  manualWeeklyMinutes?: number;
  status: PlanStatus;
  updatedAt: string;
  lastSavedFileName?: string;
  lastSavedAt?: string;
  lastSavedVersion?: number;
};

export type SavedPlanVersion = {
  id: string;
  studyPlanId: string;
  fileName: string;
  savedAt: string;
  versionNumber: number;
  status: string;
  blockCount: number;
  snapshot?: {
    config?: Record<string, unknown>;
    blocks?: Array<Record<string, unknown>>;
  };
};

export type PreviousSubjectPerformance = {
  subjectName: string;
  accuracy: number;
  completion: number;
  pendingEssential: number;
  daysSinceLastStudy: number;
};

export type GeneratedStudyBlock = {
  id: string;
  planId: string;
  weekNumber: number;
  scheduledDate: string;
  weekday: number;
  startTime: string;
  endTime: string;
  durationMinutes: number;
  activity: ActivityKind;
  activityLabel: string;
  subjectId?: string;
  subjectName: string;
  priority: string;
  estimatedQuestions: number;
  status: 'Rascunho' | 'Planejado';
  source: 'generated' | 'manual' | 'recalculated' | 'copied';
  generationKey: string;
};

export type PlanGenerationWarning = {
  code: string;
  message: string;
};

export type GeneratedWeek = {
  weekNumber: number;
  startDate: string;
  endDate: string;
  generationKey: string;
  blocks: GeneratedStudyBlock[];
  warnings: PlanGenerationWarning[];
  availableMinutes: number;
  plannedMinutes: number;
  cycles: number;
};

export type PlanWeekProjection = {
  weekNumber: number;
  startDate: string;
  endDate: string;
  expectedMinutes: number;
  prioritySubjects: string[];
  status: WeekStatus;
  completion: number;
};
